module.exports = __webpack_public_path__ + "assets/img/home-box1-sandbox.2c18e6a8.png";